import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpBackend from 'i18next-http-backend'

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'es', 'zh', 'fr', 'de', 'pt', 'ja', 'hi', 'cy', 'ga'],
    load: 'languageOnly',
    ns: ['common', 'landing', 'auth', 'features', 'resellerProgramme', 'dashboard', 'settings'],
    defaultNS: 'common',
    backend: {
      loadPath: 'locales/{{lng}}/{{ns}}.json'
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'smm_language',
    },
    interpolation: {
      escapeValue: false
    },
  })

export default i18n
